module.exports = __webpack_public_path__ + "static/payanyday_logo_back2-a726bdee51180150c6dfc97fed7450c9.jpg";